<template>
  <div>
    <v-layout row wrap>
      <v-flex xs4>
        <h2 class="title">Adicionar Pessoa</h2>
      </v-flex>

      <v-flex
        xs4
        style="text-align: right"
        v-if="categoria == 'FIADORES' && tipoPessoaFiador"
      >
        <span class="title">Tipo Pessoa:</span>
      </v-flex>
      <v-flex
        xs4
        style="padding: 0"
        v-if="categoria == 'FIADORES' && tipoPessoaFiador"
      >
        <v-radio-group
          v-model="tipoPessoa"
          row
          class="mb-0 pb-0 mt-1 pt-1"
          :mandatory="true"
        >
          <v-radio name="tipoPessoa" label="Física" :value="'FISICA'"></v-radio>
          <v-radio
            name="tipoPessoa"
            label="Jurídica"
            :value="'JURIDICA'"
          ></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-form v-model="valid" ref="form">
      <v-layout row wrap form-padding mt-4>
        <v-flex
          md4
          sm12
          v-if="tipoPessoa == 'FISICA' || categoria != 'FIADORES'"
        >
          <v-text-field
            placeholder=" "
            class="form-input-box"
            :label="'CPF'"
            v-mask="'###.###.###-##'"
            :disabled="pessoa.id_pessoa > 0"
            v-model="pessoa.documento"
            :rules="[
              (v) =>
                (v && v.length == 14) || 'CPF deve ser preenchido corretamente',
            ]"
            autofocus
          />
        </v-flex>

        <v-flex
          md4
          sm12
          v-if="
            categoria == 'FIADORES' &&
            tipoPessoaFiador &&
            tipoPessoa == 'JURIDICA'
          "
        >
          <v-text-field
            placeholder=" "
            class="form-input-box"
            :label="'CNPJ'"
            v-mask="'##.###.###/####-##'"
            :disabled="pessoa.id_pessoa > 0"
            v-model="pessoa.documento"
            :value="formatCNPJ(pessoa.documento)"
            :rules="[
              (v) =>
                (v && v.length == 18) ||
                'CNPJ deve ser preenchido corretamente',
            ]"
            autofocus
          />
        </v-flex>

        <v-flex :class="tipoPessoa == 'FISICA' ? 'md4 sm12' : 'md8 sm12'">
          <v-text-field
            placeholder=" "
            :disabled="pessoa.id_pessoa > 0"
            class="form-input-box"
            label="Nome"
            v-model="pessoa.nome"
          />
        </v-flex>
        <v-flex
          md4
          sm12
          v-if="tipoPessoa == 'FISICA' || categoria != 'FIADORES'"
        >
          <v-text-field
            placeholder=" "
            class="form-input-box"
            label="E-mail"
            :rules="[
              (v) => !!v || 'Campo obrigatório',
              (v) =>
                /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
                'E-mail tem que ser válido',
              (v) =>
                !temEmailRepetido(v) ||
                'E-mail já utilizado por ' + pessoa_nome,
            ]"
            v-model="pessoa.email"
          />
        </v-flex>
      </v-layout>
    </v-form>
    <v-layout row wrap>
      <v-flex xs2 offset-xs8>
        <button class="button jns-button blue-button mt-5" @click="close()">
          Cancelar
        </button>
      </v-flex>
      <v-flex xs2>
        <button class="button jns-button yellow-button mt-5" @click="save()">
          Salvar
        </button>
      </v-flex>
    </v-layout>
  </div>
</template>

<script lang="js">
import { formatCNPJ } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorCCGAdicionarPessoaModal",
  props: ["idTomador", "pessoa", "categoria", "pai"],
  mixins: [ViewMixin],
  data() {
    return {
      formatCNPJ,
      valid: false,
      tipoPessoa: "FISICA",
      pessoa_nome: "",
    };
  },
  computed: {
    tipoPessoaInserir() {
      if (!this.pai) {
        return "Representante";
      }
      return this.pai.tipo_pessoa == "FISICA"
        ? "Cônjuge"
        : this.pai.tipo_pessoa == "JURIDICA"
        ? "Representante"
        : "Pessoa";
    },
    readOnlyFields() {
      return this.pessoa.id_pessoa == 0;
    },
    tipoPessoaFiador() {
      if (this.pai.documento != undefined) {
        this.tipoPessoa = "FISICA";
        return false;
      } else {
        return true;
      }
    },
  },
  methods: {
    preparePayload() {
      let obj;
      let papel;
      let id_relacionamento;

      let categoria = this.categoria;
      let pai = this.pai;
      if (pai.length == 0) {
        papel =
          categoria == "REPRESENTANTES" ? "REPRESENTANTE_LEGAL" : "FIADOR";
        id_relacionamento = null;
      } else {
        papel =
          pai.tipo_pessoa == "FISICA"
            ? "CONJUGE"
            : pai.tipo_pessoa == "JURIDICA"
            ? "REPRESENTANTE_LEGAL"
            : false;

        id_relacionamento = pai.id_pessoa;
      }
      obj = {
        id_relacionamento,
        papel,
        categoria,
        nome: this.pessoa.nome,
        documento: this.pessoa.documento.replace(/\D/g, ""),
        email: this.pessoa.email,
      };
      if (!obj.id_relacionamento) delete obj.id_relacionamento;
      return obj;
    },
    async save() {
      let response;

      if (!this.valid) return;

      this.showLoadingAskWait();

      let payload = this.preparePayload(this.pessoa);

      if (payload.categoria == "FIADORES") {
        payload.tipo_pessoa = this.tipoPessoa;
      }

      // Insert
      try {
        response = await this.$store.dispatch("INSERT_CCG_PERSON", {
          pessoa: payload,
          idTomador: this.idTomador,
        });
      } catch (e) {
        this.defaultHandlerError(e);
        this.$emit("error");
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      this.$emit(
        "save",
        { tipoPessoaInserir: this.tipoPessoaInserir },
        this.pessoa
      );

      this.close();
    },
    close() {
      //this.pessoa = []
      //this.$refs.form.reset()
      this.$emit("close");
    },

    temEmailRepetido(email) {
      let temEmailRepetido = false;
      if (this.categoria == "Fiador")
        this.$store.state.ccg.ccg.fiadores.forEach((item) => {
          if (item.tipo_pessoa != "JURIDICA") {
            if (
              item.email == email &&
              this.pessoa.documento != item.documento
            ) {
              temEmailRepetido = true;
              this.pessoa_nome = item.nome;
            }
          } else {
            item.representantes.forEach((representante) => {
              if (
                representante.email == email &&
                this.pessoa.documento != representante.documento
              ) {
                temEmailRepetido = true;
                this.pessoa_nome = representante.nome;
              } else if (
                representante.conjuge &&
                representante.conjuge.email == email &&
                this.pessoa.documento != representante.conjuge.documento
              ) {
                temEmailRepetido = true;
                this.pessoa_nome = representante.conjuge.nome;
              }
            });
          }
        });
      else
        this.$store.state.ccg.ccg.representantes_legais.forEach((item) => {
          if (item.email == email && this.pessoa.documento != item.documento) {
            temEmailRepetido = true;
            this.pessoa_nome = item.nome;
          } else if (
            item.conjuge &&
            item.conjuge.email == email &&
            this.pessoa.documento != item.conjuge.documento
          ) {
            temEmailRepetido = true;
            this.pessoa_nome = item.conjuge.nome;
          }
        });
      if (temEmailRepetido) this.$forceUpdate();

      return temEmailRepetido;
    },
  },
  mounted() {
    // Se não houver pai, for um representante e não FIADOR inicia com pessoa física
    if (this.pai.documento != undefined) {
      this.tipoPessoa = "FISICA";
    }
  },
};
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// ./src/components/TomadorCCGAdicionarPessoaModal.vue